// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-sidebar .flux-toolbar{flex-direction:column}.flow-nonsidebar{position:absolute;top:0;right:0;bottom:0;width:300px}.flow-nonsidebar .flux-toolbar{flex-direction:column;background-color:#1a1a2a}.flow-panel--body .flux-editor--monaco{height:100%;position:static}.flow-sidebar--secrets-list{height:100%}", ""]);
// Exports
module.exports = exports;
